export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_RESPONSE = 'LOGIN_RESPONSE';
export const LOGIN_RESPONSE_ERROR = 'LOGIN_RESPONSE_ERROR';

export const RESET_PASS_REQUEST = 'RESET_PASS_REQUEST';
export const RESET_PASS_RESPONSE = 'RESET_PASS_RESPONSE';
export const RESET_PASS_RESPONSE_ERROR = 'RESET_PASS_RESPONSE_ERROR';

export const RESET_PASS_EMAIL_REQUEST = 'RESET_PASS_EMAIL_REQUEST';
export const RESET_PASS_EMAIL_RESPONSE = 'RESET_PASS_EMAIL_RESPONSE';
export const RESET_PASS_EMAIL_RESPONSE_ERROR = 'RESET_PASS_EMAIL_RESPONSE_ERROR';

export const CLEAN_RESET_PASS_EMAIL_STATE = 'CLEAN_RESET_PASS_EMAIL_STATE';
export const CLEAN_RESET_PASS_STATE = 'CLEAN_RESET_PASS_STATE';

export const LOGOUT = 'LOGOUT';

const loginActions = {
    loginRequest: (body) => ({type: LOGIN_REQUEST, body}),
    loginResponse: (response) => ({type: LOGIN_RESPONSE, response: response}),
    loginResponseError: (error) => ({type: LOGIN_RESPONSE_ERROR, error}),

    resetPassRequest: (body) => ({type: RESET_PASS_REQUEST, body}),
    resetPassResponse: (response) => ({type: RESET_PASS_RESPONSE, response: response}),
    resetPassResponseError: (error) => ({type: RESET_PASS_RESPONSE_ERROR, error}),

    resetPassEmailRequest: (body) => ({type: RESET_PASS_EMAIL_REQUEST, body}),
    resetPassEmailResponse: (response) => ({type: RESET_PASS_EMAIL_RESPONSE, response: response}),
    resetPassEmailResponseError: (error) => ({type: RESET_PASS_EMAIL_RESPONSE_ERROR, error}),

    cleanResetPassEmailState: () => ({type: CLEAN_RESET_PASS_EMAIL_STATE}),
    cleanResetPassState: () => ({type: CLEAN_RESET_PASS_STATE}),
    logout: () => ({type: LOGOUT}),
};

export default loginActions;
